import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Constants } from 'src/app/modules/shared/models/constants';

type MapDrawingMode = 'draw' | 'none';

@Component({
    selector: 'app-drawing-controls',
    templateUrl: './drawing-controls.component.html',
    styleUrl: './drawing-controls.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DrawingControlsComponent {
  @Input() drawingState: boolean = false;
  @Output() drawingStateChanged = new EventEmitter<boolean>();

  public isMobile = false;

  constructor(
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
      this.isMobile = window.innerWidth < Constants.xs;
  }

  public onDrawClick() {
    this.drawingState = true;
    this.changeDetector.markForCheck();
    this.drawingStateChanged.emit(this.drawingState);
  }

  public onCancelDrawClick() {
    this.drawingState = false;
    this.changeDetector.markForCheck();
    this.drawingStateChanged.emit(this.drawingState);
  }
}
